import { Box, CircularProgress } from "@mui/material";
import "../styles/AppCard.css";

function Loader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress style={{ color: "#00d4fa" }} />
      <p className="message" style={{ color: "white", padding: "10px" }}>
        Loading...
      </p>
    </Box>
  );
}

export default Loader;
